import { BasketDetails } from 'shared-types/Basket';

export const applyVouchersToBasketTotal = (basketDetails: BasketDetails): BasketDetails => {
  const { vouchers, total, discountTotals } = basketDetails;
  const vouchersTotal = (vouchers || []).reduce((acc, voucher) => {
    return acc + voucher.redemptionTotal.amount;
  }, 0);
  return {
    ...basketDetails,
    total: { amount: total.amount - vouchersTotal, currencyCode: total.currencyCode },
    discountTotals: discountTotals && {
      ...discountTotals,
      discountedTotal: { amount: total.amount - vouchersTotal, currencyCode: total.currencyCode },
    },
  };
};
